import restaurant from "@/lib/restaurant.json";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import seo from "@/lib/seo.json";

export default function RouteMetadata() {
  const location = useLocation();
  const pathname = location.pathname.replace(/\/$/, "") || "/";
  useEffect(() => {
    const path = seo.aliases[pathname] || pathname;
    const page = seo.pages[path];
    const title = page?.[0] || "Velpula Mess | Ordering & Staff Services";
    const description = page?.[1] || "Manage your Velpula Mess order or sign in to your account.";
    document.title = title;
    const meta = (attribute, key, content) => {
      let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
      if (!element) { element = document.createElement("meta"); element.setAttribute(attribute, key); document.head.appendChild(element); }
      element.setAttribute("content", content);
    };
    meta("name", "description", description);
    meta("name", "robots", page ? "index, follow" : "noindex, nofollow");
    for (const [key, content] of [["title", title], ["description", description], ["image", `${seo.origin}/logo.png`]]) {
      meta("property", `og:${key}`, content);
      meta("name", `twitter:${key}`, content);
    }
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (page) {
      if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
      canonical.href = seo.origin + path;
      meta("property", "og:url", seo.origin + path);
    } else {
      canonical?.remove();
      document.head.querySelector('meta[property="og:url"]')?.remove();
    }
    document.getElementById("restaurant-schema")?.remove();
    if (pathname === "/") {
      const script = document.createElement("script");
      script.id = "restaurant-schema";
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(restaurant);
      document.head.appendChild(script);
    }
    // Track SPA dynamic page view in Google Analytics (GA4)
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_title: title,
        page_location: window.location.href,
        page_path: pathname,
      });
    }
  }, [pathname]);
  return null;
}
